import env from 'env/env';
import { pathJoin } from 'utils/general';

export const rootPath = (path: string) => pathJoin(env.root, path);
